import { render } from "./TokenPanel.vue?vue&type=template&id=71abee02&scoped=true"
import script from "./TokenPanel.vue?vue&type=script&lang=js"
export * from "./TokenPanel.vue?vue&type=script&lang=js"

import "./TokenPanel.vue?vue&type=style&index=0&id=71abee02&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71abee02"]])

export default __exports__